export const DEFAULT_PAGINATION_LIMIT = 1000;
export const DEFAULT_VISIBLE_PAGE_SIZE = 100;
export const SHORT_VISIBLE_PAGE_SIZE = 24;
